module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-8.302 17.18l-4.644 6.252c-.58.8-1.526.728-2.108-.072L10.3 17.214c-.582-.802-.296-1.214.636-1.214H14V8.996A.997.997 0 0 1 15 8h2c.552 0 1 .444 1 .996V16h3.064c.932 0 1.216.378.634 1.18z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-square-3.js
// module id = 1116
// module chunks = 14